export default {
    excess: 'Selvrisiko',
    security: 'Depositum',
    fuel_policy: 'Brændstofpolitik',
    like_for_like: 'Lige for lige',
    full_to_full: 'Fuld til fuld',
    mileage: 'Kilometer: {mileage} mil pr. leje',
    unlimited_mileage: 'Ubegrænset kilometer',
    non_refundable: 'Ikke-refunderbar',
    free_cancellation_until: 'Gratis afbestilling indtil {date}',
    cancellation_with_terms: 'Afbestilling {0} i overensstemmelse med ',
    t_c_text: 'Vilkår',
    two_free_extras: 'To gratis tilvalg ved afhentning',
    glass_tyres_covered: 'Glas og dæk er dækket',
    spec_fuel_petrol: 'benzin',
    spec_fuel_petrol_diesel: 'benzin/diesel',
};
